export default class EntityRepresentativeAPIResponse {
    id?: string;
    userId?: string;
    entityId?: string;
    firstName?: string;
    lastName?: string;
}
